import { useQueryClient, useMutation } from 'react-query';
import { toast } from 'react-toastify';
import restFactory from 'v2/utils/restFactory';
import { infiniteUserInvitesKeys } from './query-keys';

type UserInvite = {
  organization: number;
  email: string;
  licenses?: string[];
};

async function bulkCreateUserInvites(userInvites: UserInvite[]) {
  return await restFactory.post('/dj/api/v1/invite_user/bulk/', userInvites);
}

type UseBulkCreateUserInvitesProps = {
  onSuccess?: () => void;
};

export function useBulkCreateUserInvites({
  onSuccess,
}: UseBulkCreateUserInvitesProps) {
  const queryClient = useQueryClient();

  return useMutation(bulkCreateUserInvites, {
    onSuccess: async () => {
      onSuccess?.();
      await queryClient.invalidateQueries(infiniteUserInvitesKeys.all);
      toast.success('Invitations were sent successfully.');
    },
    onError: () => {
      toast.error('Failed to send invitations.');
    },
  });
}
